<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="text-center">
            <h5>
              Deduplicate {{ campaignDescription["campaign_name"] }} CSV Data
            </h5>

            <p class="mt-5">
              These are the list of new and old csv accounts. Upper is the old
              accounts for campaign and below are the newaccounts Please click
              accept to make changes or ignore to do nothing.
            </p>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button @click="completedDeduplicate">Finished</vs-button>
        </vs-col>
      </vs-row>


      <template v-for="(matched_account, key) in match_accounts">

        
        <vs-table stripe :key="key" :data="matched_account" class="mt-10">
          <template slot="thead">
            <vs-th>Company</vs-th>
            <vs-th
              v-if="matched_account[0].actual_account_name && matched_account[1].actual_account_name &&
                matched_account[0].actual_account_name.toLowerCase()  !==
                  matched_account[1].actual_account_name.toLowerCase()
              "
              >Actual Company Name</vs-th
            >
            <vs-th 
              v-if="matched_account[0].phone && matched_account[1].phone &&
            matched_account[0].phone.toLowerCase()  !== matched_account[1].phone.toLowerCase()"
              >Phone</vs-th
            >
            <vs-th
              v-if="matched_account[0].switchboard && matched_account[1].switchboard &&
                matched_account[0].switchboard.toLowerCase()  !==
                  matched_account[1].switchboard.toLowerCase()
              "
              >Switchboard</vs-th
            >
            <vs-th
              v-if="matched_account[0].site_switchboard && matched_account[1].site_switchboard &&
                matched_account[0].site_switchboard.toLowerCase()  !==
                  matched_account[1].site_switchboard.toLowerCase()
              "
              >Site Switchboard</vs-th
            >
            <vs-th
              v-if="matched_account[0].registered_office_address_1 && matched_account[1].registered_office_address_1 &&
                matched_account[0].registered_office_address_1.toLowerCase()  !==
                  matched_account[1].registered_office_address_1.toLowerCase()
              "
              >Registered Office Address 1</vs-th
            >
            <vs-th
              v-if="matched_account[0].registered_office_address_2 && matched_account[1].registered_office_address_2 &&
                matched_account[0].registered_office_address_2.toLowerCase()  !==
                  matched_account[1].registered_office_address_2.toLowerCase()
              "
              >Registered Office Address 2</vs-th
            >
            <vs-th
              v-if="matched_account[0].registered_office_address_3 && matched_account[1].registered_office_address_3 &&
                matched_account[0].registered_office_address_3.toLowerCase()  !==
                  matched_account[1].registered_office_address_3.toLowerCase()
              "
              >Registered Office Address 3</vs-th
            >
            <vs-th
              v-if="matched_account[0].registered_office_city && matched_account[1].registered_office_city &&
                matched_account[0].registered_office_city.toLowerCase()  !==
                  matched_account[1].registered_office_city.toLowerCase()
              "
              >Registered Office City</vs-th
            >
            <vs-th
              v-if="matched_account[0].registered_office_county && matched_account[1].registered_office_county &&
                matched_account[0].registered_office_county.toLowerCase()  !==
                  matched_account[1].registered_office_county.toLowerCase()
              "
              >Registered Office County</vs-th
            >
            <vs-th
              v-if="matched_account[0].registered_office_postcode && matched_account[1].registered_office_postcode &&
                matched_account[0].registered_office_postcode.toLowerCase()  !==
                  matched_account[1].registered_office_postcode.toLowerCase()
              "
              >Registered Office Postcode</vs-th
            >
            <vs-th
              v-if="matched_account[0].registered_office_country && matched_account[1].registered_office_country &&
                matched_account[0].registered_office_country.toLowerCase()  !==
                  matched_account[1].registered_office_country.toLowerCase()
              "
              >Registered Office Country</vs-th
            >
            <vs-th
              v-if="matched_account[0].head_office_address_1 && matched_account[1].head_office_address_1 &&
                matched_account[0].head_office_address_1.toLowerCase()  !==
                  matched_account[1].head_office_address_1.toLowerCase()
              "
              >Head Office Address 1</vs-th
            >
            <vs-th
              v-if="matched_account[0].head_office_address_2 && matched_account[1].head_office_address_2 &&
                matched_account[0].head_office_address_2.toLowerCase()  !==
                  matched_account[1].head_office_address_2.toLowerCase()
              "
              >Head Office Address 2</vs-th
            >
            <vs-th
              v-if="matched_account[0].head_office_address_3 && matched_account[1].head_office_address_3 &&
                matched_account[0].head_office_address_3.toLowerCase()  !==
                  matched_account[1].head_office_address_3.toLowerCase()
              "
              >Head Office Address 3</vs-th
            >
            <vs-th
              v-if="matched_account[0].head_office_city && matched_account[1].head_office_city &&
                matched_account[0].head_office_city.toLowerCase()  !==
                  matched_account[1].head_office_city.toLowerCase()
              "
              >Head Office City</vs-th
            >
            <vs-th
              v-if="matched_account[0].head_office_county && matched_account[1].head_office_county &&
                matched_account[0].head_office_county.toLowerCase()  !==
                  matched_account[1].head_office_county.toLowerCase()
              "
              >Head Office County</vs-th
            >
            <vs-th
              v-if="matched_account[0].head_office_postcode && matched_account[1].head_office_postcode &&
                matched_account[0].head_office_postcode.toLowerCase()  !==
                  matched_account[1].head_office_postcode.toLowerCase()
              "
              >Head Office Postcode</vs-th
            >
            <vs-th
              v-if="matched_account[0].head_office_country && matched_account[1].head_office_country &&
                matched_account[0].head_office_country.toLowerCase()  !==
                  matched_account[1].head_office_country.toLowerCase()
              "
              >Head Office Country</vs-th
            >

            <vs-th
              v-if="matched_account[0].company_registration_number && matched_account[1].company_registration_number &&
                matched_account[0].company_registration_number.toLowerCase()  !==
                  matched_account[1].company_registration_number.toLowerCase()
              "
              >Registration No.</vs-th
            >

            <vs-th
              v-if="matched_account[0].registration_jurisdiction && matched_account[1].registration_jurisdiction &&
                matched_account[0].registration_jurisdiction.toLowerCase()  !==
                  matched_account[1].registration_jurisdiction.toLowerCase()
              "
              >Registration Jurisdiction</vs-th
            >
            <vs-th
              v-if="
                matched_account[0].no_of_employees  !==
                  matched_account[1].no_of_employees
              "
              >No of Employees</vs-th
            >
            <vs-th
              v-if="
              matched_account[0].revenue  !== matched_account[1].revenue"
              >Revenue</vs-th
            >

            <vs-th 
              v-if="matched_account[0].web && matched_account[1].web &&
            matched_account[0].web.toLowerCase()  !== matched_account[1].web"
              >Web</vs-th
            >

            <vs-th
              v-if="matched_account[0].linkedin && matched_account[1].linkedin &&
              matched_account[0].linkedin.toLowerCase()  !== matched_account[1].linkedin"
              >LinkedIn</vs-th
            >

            <vs-th>
              Action
            </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              v-for="(duplicate_matched_account, index) in matched_account"
            >
              <vs-td>
                {{ duplicate_matched_account.company_name? duplicate_matched_account.company_name : duplicate_matched_account.company  }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].actual_account_name && matched_account[1].actual_account_name &&
                  matched_account[0].actual_account_name.toLowerCase()  !==
                    matched_account[1].actual_account_name.toLowerCase()
                "
              >
                {{ duplicate_matched_account.actual_account_name }}
              </vs-td>

              <vs-td
              v-if="matched_account[0].phone && matched_account[1].phone &&
                matched_account[0].phone.toLowerCase()  !== matched_account[1].phone"
              >
                {{ duplicate_matched_account.phone }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].switchboard && matched_account[1].switchboard &&
                  matched_account[0].switchboard.toLowerCase()  !==
                    matched_account[1].switchboard.toLowerCase()
                "
              >
                {{ duplicate_matched_account.switchboard }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].site_switchboard && matched_account[1].site_switchboard &&
                  matched_account[0].site_switchboard.toLowerCase()  !==
                    matched_account[1].site_switchboard.toLowerCase()
                "
              >
                {{ duplicate_matched_account.site_switchboard }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].registered_office_address_1 && matched_account[1].registered_office_address_1 &&
                  matched_account[0].registered_office_address_1.toLowerCase()  !==
                    matched_account[1].registered_office_address_1.toLowerCase()
                "
              >
                {{ duplicate_matched_account.registered_office_address_1 }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].registered_office_address_2 && matched_account[1].registered_office_address_2 &&
                  matched_account[0].registered_office_address_2.toLowerCase()  !==
                    matched_account[1].registered_office_address_2.toLowerCase()
                "
              >
                {{ duplicate_matched_account.registered_office_address_2 }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].registered_office_address_3 && matched_account[1].registered_office_address_3 &&
                  matched_account[0].registered_office_address_3.toLowerCase()  !==
                    matched_account[1].registered_office_address_3.toLowerCase()
                "
              >
                {{ duplicate_matched_account.registered_office_address_3 }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].registered_office_city && matched_account[1].registered_office_city &&
                  matched_account[0].registered_office_city.toLowerCase()  !==
                    matched_account[1].registered_office_city.toLowerCase()
                "
              >
                {{ duplicate_matched_account.registered_office_city }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].registered_office_county && matched_account[1].registered_office_county &&
                  matched_account[0].registered_office_county.toLowerCase()  !==
                    matched_account[1].registered_office_county.toLowerCase()
                "
              >
                {{ duplicate_matched_account.registered_office_county }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].registered_office_postcode && matched_account[1].registered_office_postcode &&
                  matched_account[0].registered_office_postcode.toLowerCase()  !==
                    matched_account[1].registered_office_postcode.toLowerCase()
                "
              >
                {{ duplicate_matched_account.registered_office_postcode }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].registered_office_country && matched_account[1].registered_office_country &&
                  matched_account[0].registered_office_country.toLowerCase()  !==
                    matched_account[1].registered_office_country.toLowerCase()
                "
              >
                {{ duplicate_matched_account.registered_office_country }}
              </vs-td>

              <vs-td
              v-if="matched_account[0].head_office_address_1 && matched_account[1].head_office_address_1 &&
                  matched_account[0].head_office_address_1.toLowerCase()  !==
                    matched_account[1].head_office_address_1.toLowerCase()
                "
              >
                {{ duplicate_matched_account.head_office_address_1 }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].head_office_address_2 && matched_account[1].head_office_address_2 &&
                  matched_account[0].head_office_address_2.toLowerCase()  !==
                    matched_account[1].head_office_address_2.toLowerCase()
                "
              >
                {{ duplicate_matched_account.head_office_address_2 }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].head_office_address_3 && matched_account[1].head_office_address_3 &&
                  matched_account[0].head_office_address_3.toLowerCase()  !==
                    matched_account[1].head_office_address_3.toLowerCase()
                "
              >
                {{ duplicate_matched_account.head_office_address_3 }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].head_office_city && matched_account[1].head_office_city &&
                  matched_account[0].head_office_city.toLowerCase()  !==
                    matched_account[1].head_office_city.toLowerCase()
                "
              >
                {{ duplicate_matched_account.head_office_city }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].head_office_county && matched_account[1].head_office_county &&
                  matched_account[0].head_office_county.toLowerCase()  !==
                    matched_account[1].head_office_county.toLowerCase()
                "
              >
                {{ duplicate_matched_account.head_office_county }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].head_office_postcode && matched_account[1].head_office_postcode &&
                  matched_account[0].head_office_postcode.toLowerCase()  !==
                    matched_account[1].head_office_postcode.toLowerCase()
                "
              >
                {{ duplicate_matched_account.head_office_postcode }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].head_office_country && matched_account[1].head_office_country &&
                  matched_account[0].head_office_country.toLowerCase()  !==
                    matched_account[1].head_office_country.toLowerCase()
                "
              >
                {{ duplicate_matched_account.head_office_country }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].company_registration_number && matched_account[1].company_registration_number &&
                  matched_account[0].company_registration_number.toLowerCase()  !==
                    matched_account[1].company_registration_number.toLowerCase()
                "
              >
                {{ duplicate_matched_account.company_registration_number }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].registration_jurisdiction && matched_account[1].registration_jurisdiction &&
                  matched_account[1].registration_jurisdiction.toLowerCase()  !==
                    matched_account[0].registration_jurisdiction.toLowerCase()
                "
              >
                {{ duplicate_matched_account.registration_jurisdiction }}
              </vs-td>
              <vs-td
                v-if="
                  matched_account[1].no_of_employees  !==
                    matched_account[0].no_of_employees
                "
              >
                {{ duplicate_matched_account.no_of_employees }}
              </vs-td>
              <vs-td
                v-if="matched_account[1].revenue  !== matched_account[0].revenue"
              >
                {{ duplicate_matched_account.revenue }}
              </vs-td>

              <vs-td 
              v-if="matched_account[0].web && matched_account[1].web &&
              matched_account[0].web.toLowerCase()  !== matched_account[1].web">
                {{ duplicate_matched_account.web }}
              </vs-td>
              <vs-td
              v-if="matched_account[0].linkedin && matched_account[1].linkedin &&
                  matched_account[0].linkedin.toLowerCase()  !== matched_account[1].linkedin.toLowerCase()
                "
              >
                {{ duplicate_matched_account.linkedin }}
              </vs-td>

              <vs-td>
                <template v-if="index === 1">
                  <vs-button @click="acceptToUpdate(duplicate_matched_account)"
                    >Accept</vs-button
                  >
                </template>

                <template v-if="index === 0">
                  <vs-button
                    @click="IgnoreUpdateToMasterDB(duplicate_matched_account)"
                    >Ignore</vs-button
                  >
                </template>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
    </vx-card>
    <vs-popup
      fullscreen
      style="z-index: 999999;"
      class="holamundo"
      title="Enrich New Csv Data To Old Csv"
      :active.sync="enrichAccountDataToMasterDBPopUp"
    >
      <div class="text-center">
        <h6 class="mb-2">
          <!-- Account : {{ accountDataDescription.company_name }} -->
        </h6>
        <p>
          These are the list of accounts from old csv and accounts from new csv.
          Please click on checkbox and submit in order to add in old csv.
        </p>
      </div>

      <vs-row vs-w="12" class="mb-10 mt-10">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> New Uploaded CSV </u></h6>
            </div>
          </div>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Old Uploaded CSV</u></h6>
            </div>
          </div>
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].company_name !=
              accountDataDescriptions[1].company_name
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].company_name !=
              accountDataDescriptions[1].company_name
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Company Name :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.company_name != null &&
                      accountDataDescriptions[0].company_name !=
                        accountDataDescriptions[1].company_name
                  "
                  v-model="accounts.company_name"
                  :vs-value="accountDataDescription.company_name"
                  class="mr-4"
                  vs-name="actual_account_name"
                  >{{ accountDataDescription.company_name }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.company_name == null
                      ? "EMPTY"
                      : accountDataDescription.company_name
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.company_name == null
                      ? "EMPTY"
                      : accountDataDescription.company_name
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].actual_account_name !=
              accountDataDescriptions[1].actual_account_name
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].actual_account_name !=
              accountDataDescriptions[1].actual_account_name
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Actual Account Name :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.actual_account_name != null &&
                      accountDataDescriptions[0].actual_account_name !=
                        accountDataDescriptions[1].actual_account_name
                  "
                  v-model="accounts.actual_account_name"
                  :vs-value="accountDataDescription.actual_account_name"
                  class="mr-4"
                  vs-name="actual_account_name"
                  >{{ accountDataDescription.actual_account_name }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.actual_account_name == null
                      ? "EMPTY"
                      : accountDataDescription.actual_account_name
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.actual_account_name == null
                      ? "EMPTY"
                      : accountDataDescription.actual_account_name
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].company_registration_number !=
              accountDataDescriptions[1].company_registration_number
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].company_registration_number !=
              accountDataDescriptions[1].company_registration_number
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Company Registration Number :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.company_registration_number !=
                      null &&
                      accountDataDescriptions[0].company_registration_number !=
                        accountDataDescriptions[1].company_registration_number
                  "
                  v-model="accounts.company_registration_number"
                  :vs-value="accountDataDescription.company_registration_number"
                  class="mr-4"
                  vs-name="company_registration_number"
                  >{{ accountDataDescription.company_registration_number }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.company_registration_number == null
                      ? "EMPTY"
                      : accountDataDescription.company_registration_number
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.company_registration_number == null
                      ? "EMPTY"
                      : accountDataDescription.company_registration_number
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>
        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].registered_office_address_1 !=
              accountDataDescriptions[1].registered_office_address_1
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].registered_office_address_1 !=
              accountDataDescriptions[1].registered_office_address_1
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Registered Office Address 1 :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.registered_office_address_1 !=
                      null &&
                      accountDataDescriptions[0].registered_office_address_1 !=
                        accountDataDescriptions[1].registered_office_address_1
                  "
                  v-model="accounts.registered_office_address_1"
                  :vs-value="accountDataDescription.registered_office_address_1"
                  class="mr-4"
                  vs-name="registered_office_address_1"
                  >{{ accountDataDescription.registered_office_address_1 }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.registered_office_address_1 == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_address_1
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.registered_office_address_1 == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_address_1
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].registered_office_address_2 !=
              accountDataDescriptions[1].registered_office_address_2
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].registered_office_address_2 !=
              accountDataDescriptions[1].registered_office_address_2
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Registered Office Address 2 :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.registered_office_address_2 !=
                      null &&
                      accountDataDescriptions[0].registered_office_address_2 !=
                        accountDataDescriptions[1].registered_office_address_2
                  "
                  v-model="accounts.registered_office_address_2"
                  :vs-value="accountDataDescription.registered_office_address_2"
                  class="mr-4"
                  vs-name="registered_office_address_2"
                  >{{ accountDataDescription.registered_office_address_2 }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.registered_office_address_2 == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_address_2
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.registered_office_address_2 == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_address_2
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].registered_office_address_3 !=
              accountDataDescriptions[1].registered_office_address_3
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].registered_office_address_3 !=
              accountDataDescriptions[1].registered_office_address_3
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Registered Office Address 3 :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.registered_office_address_3 !=
                      null &&
                      accountDataDescriptions[0].registered_office_address_3 !=
                        accountDataDescriptions[1].registered_office_address_3
                  "
                  v-model="accounts.registered_office_address_3"
                  :vs-value="accountDataDescription.registered_office_address_3"
                  class="mr-4"
                  vs-name="registered_office_address_3"
                  >{{ accountDataDescription.registered_office_address_3 }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.registered_office_address_3 == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_address_3
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.registered_office_address_3 == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_address_3
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].registered_office_city !=
              accountDataDescriptions[1].registered_office_city
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].registered_office_city !=
              accountDataDescriptions[1].registered_office_city
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Registered Office City :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.registered_office_city != null &&
                      accountDataDescriptions[0].registered_office_city !=
                        accountDataDescriptions[1].registered_office_city
                  "
                  v-model="accounts.registered_office_city"
                  :vs-value="accountDataDescription.registered_office_city"
                  class="mr-4"
                  vs-name="registered_office_city"
                  >{{ accountDataDescription.registered_office_city }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.registered_office_city == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_city
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.registered_office_city == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_city
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].registered_office_county !=
              accountDataDescriptions[1].registered_office_county
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].registered_office_county !=
              accountDataDescriptions[1].registered_office_county
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Registered Office County :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.registered_office_county != null &&
                      accountDataDescriptions[0].registered_office_county !=
                        accountDataDescriptions[1].registered_office_county
                  "
                  v-model="accounts.registered_office_county"
                  :vs-value="accountDataDescription.registered_office_county"
                  class="mr-4"
                  vs-name="registered_office_county"
                  >{{ accountDataDescription.registered_office_county }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.registered_office_county == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_county
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.registered_office_county == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_county
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].registered_office_postcode !=
              accountDataDescriptions[1].registered_office_postcode
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].registered_office_postcode !=
              accountDataDescriptions[1].registered_office_postcode
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Registered Office Postcode :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.registered_office_postcode != null &&
                      accountDataDescriptions[0].registered_office_postcode !=
                        accountDataDescriptions[1].registered_office_postcode
                  "
                  v-model="accounts.registered_office_postcode"
                  :vs-value="accountDataDescription.registered_office_postcode"
                  class="mr-4"
                  vs-name="registered_office_postcode"
                  >{{ accountDataDescription.registered_office_postcode }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.registered_office_postcode == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_postcode
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.registered_office_postcode == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_postcode
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].registered_office_country !=
              accountDataDescriptions[1].registered_office_country
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].registered_office_country !=
              accountDataDescriptions[1].registered_office_country
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Registered Office Country :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.registered_office_country != null &&
                      accountDataDescriptions[0].registered_office_country !=
                        accountDataDescriptions[1].registered_office_country
                  "
                  v-model="accounts.registered_office_country"
                  :vs-value="accountDataDescription.registered_office_country"
                  class="mr-4"
                  vs-name="registered_office_country"
                  >{{ accountDataDescription.registered_office_country }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.registered_office_country == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_country
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.registered_office_country == null
                      ? "EMPTY"
                      : accountDataDescription.registered_office_country
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].head_office_address_1 !=
              accountDataDescriptions[1].head_office_address_1
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].head_office_address_1 !=
              accountDataDescriptions[1].head_office_address_1
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Head Office Address 1 :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.head_office_address_1 != null &&
                      accountDataDescriptions[0].head_office_address_1 !=
                        accountDataDescriptions[1].head_office_address_1
                  "
                  v-model="accounts.head_office_address_1"
                  :vs-value="accountDataDescription.head_office_address_1"
                  class="mr-4"
                  vs-name="head_office_address_1"
                  >{{ accountDataDescription.head_office_address_1 }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.head_office_address_1 == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_address_1
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.head_office_address_1 == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_address_1
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].head_office_address_2 !=
              accountDataDescriptions[1].head_office_address_2
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].head_office_address_2 !=
              accountDataDescriptions[1].head_office_address_2
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Head Office Address 2 :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.head_office_address_2 != null &&
                      accountDataDescriptions[0].head_office_address_2 !=
                        accountDataDescriptions[1].head_office_address_2
                  "
                  v-model="accounts.head_office_address_2"
                  :vs-value="accountDataDescription.head_office_address_2"
                  class="mr-4"
                  vs-name="head_office_address_2"
                  >{{ accountDataDescription.head_office_address_2 }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.head_office_address_2 == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_address_2
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.head_office_address_2 == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_address_2
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].head_office_address_3 !=
              accountDataDescriptions[1].head_office_address_3
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].head_office_address_3 !=
              accountDataDescriptions[1].head_office_address_3
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Head Office Address 3 :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.head_office_address_3 != null &&
                      accountDataDescriptions[0].head_office_address_3 !=
                        accountDataDescriptions[1].head_office_address_3
                  "
                  v-model="accounts.head_office_address_3"
                  :vs-value="accountDataDescription.head_office_address_3"
                  class="mr-4"
                  vs-name="head_office_address_3"
                  >{{ accountDataDescription.head_office_address_3 }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.head_office_address_3 == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_address_3
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.head_office_address_3 == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_address_3
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].head_office_city !=
              accountDataDescriptions[1].head_office_city
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].head_office_city !=
              accountDataDescriptions[1].head_office_city
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Head Office City :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.head_office_city != null &&
                      accountDataDescriptions[0].head_office_city !=
                        accountDataDescriptions[1].head_office_city
                  "
                  v-model="accounts.head_office_city"
                  :vs-value="accountDataDescription.head_office_city"
                  class="mr-4"
                  vs-name="head_office_city"
                  >{{ accountDataDescription.head_office_city }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.head_office_city == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_city
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.head_office_city == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_city
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].head_office_county !=
              accountDataDescriptions[1].head_office_county
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].head_office_county !=
              accountDataDescriptions[1].head_office_county
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Head Office County :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.head_office_county != null &&
                      accountDataDescriptions[0].head_office_county !=
                        accountDataDescriptions[1].head_office_county
                  "
                  v-model="accounts.head_office_county"
                  :vs-value="accountDataDescription.head_office_county"
                  class="mr-4"
                  vs-name="head_office_county"
                  >{{ accountDataDescription.head_office_county }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.head_office_county == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_county
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.head_office_county == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_county
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].head_office_postcode !=
              accountDataDescriptions[1].head_office_postcode
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].head_office_postcode !=
              accountDataDescriptions[1].head_office_postcode
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Head Office Postcode :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.head_office_postcode != null &&
                      accountDataDescriptions[0].head_office_postcode !=
                        accountDataDescriptions[1].head_office_postcode
                  "
                  v-model="accounts.head_office_postcode"
                  :vs-value="accountDataDescription.head_office_postcode"
                  class="mr-4"
                  vs-name="head_office_postcode"
                  >{{ accountDataDescription.head_office_postcode }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.head_office_postcode == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_postcode
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.head_office_postcode == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_postcode
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].head_office_country !=
              accountDataDescriptions[1].head_office_country
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].head_office_country !=
              accountDataDescriptions[1].head_office_country
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Head Office Country :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.head_office_country != null &&
                      accountDataDescriptions[0].head_office_country !=
                        accountDataDescriptions[1].head_office_country
                  "
                  v-model="accounts.head_office_country"
                  :vs-value="accountDataDescription.head_office_country"
                  class="mr-4"
                  vs-name="head_office_country"
                  >{{ accountDataDescription.head_office_country }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.head_office_country == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_country
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.head_office_country == null
                      ? "EMPTY"
                      : accountDataDescription.head_office_country
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>
        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].revenue !=
              accountDataDescriptions[1].revenue
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].revenue !=
              accountDataDescriptions[1].revenue
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Revenue :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.revenue != null &&
                      accountDataDescriptions[0].revenue !=
                        accountDataDescriptions[1].revenue
                  "
                  v-model="accounts.revenue"
                  :vs-value="accountDataDescription.revenue"
                  class="mr-4"
                  vs-name="revenue"
                  >{{ accountDataDescription.revenue }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.revenue == null
                      ? "EMPTY"
                      : accountDataDescription.revenue
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.revenue == null
                      ? "EMPTY"
                      : accountDataDescription.revenue
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].no_of_employees !=
              accountDataDescriptions[1].no_of_employees
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].no_of_employees !=
              accountDataDescriptions[1].no_of_employees
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>No Of Employees :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.no_of_employees != null &&
                      accountDataDescriptions[0].no_of_employees !=
                        accountDataDescriptions[1].no_of_employees
                  "
                  v-model="accounts.no_of_employees"
                  :vs-value="accountDataDescription.no_of_employees"
                  class="mr-4"
                  vs-name="no_of_employees"
                  >{{ accountDataDescription.no_of_employees }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.no_of_employees == null
                      ? "EMPTY"
                      : accountDataDescription.no_of_employees
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.no_of_employees == null
                      ? "EMPTY"
                      : accountDataDescription.no_of_employees
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>
        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].registration_jurisdiction !=
              accountDataDescriptions[1].registration_jurisdiction
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].registration_jurisdiction !=
              accountDataDescriptions[1].registration_jurisdiction
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Registration Jurisdiction :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.registration_jurisdiction != null &&
                      accountDataDescriptions[0].registration_jurisdiction !=
                        accountDataDescriptions[1].registration_jurisdiction
                  "
                  v-model="accounts.registration_jurisdiction"
                  :vs-value="accountDataDescription.registration_jurisdiction"
                  class="mr-4"
                  vs-name="registration_jurisdiction"
                  >{{ accountDataDescription.registration_jurisdiction }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.registration_jurisdiction == null
                      ? "EMPTY"
                      : accountDataDescription.registration_jurisdiction
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.registration_jurisdiction == null
                      ? "EMPTY"
                      : accountDataDescription.registration_jurisdiction
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].switchboard !=
              accountDataDescriptions[1].switchboard
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].switchboard !=
              accountDataDescriptions[1].switchboard
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Switchboard :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.switchboard != null &&
                      accountDataDescriptions[0].switchboard !=
                        accountDataDescriptions[1].switchboard
                  "
                  v-model="accounts.switchboard"
                  :vs-value="accountDataDescription.switchboard"
                  class="mr-4"
                  vs-name="switchboard"
                  >{{ accountDataDescription.switchboard }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.switchboard == null
                      ? "EMPTY"
                      : accountDataDescription.switchboard
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.switchboard == null
                      ? "EMPTY"
                      : accountDataDescription.switchboard
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>
        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].site_switchboard !=
              accountDataDescriptions[1].site_switchboard
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].site_switchboard !=
              accountDataDescriptions[1].site_switchboard
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Site Switchboard :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.site_switchboard != null &&
                      accountDataDescriptions[0].site_switchboard !=
                        accountDataDescriptions[1].site_switchboard
                  "
                  v-model="accounts.site_switchboard"
                  :vs-value="accountDataDescription.site_switchboard"
                  class="mr-4"
                  vs-name="site_switchboard"
                  >{{ accountDataDescription.site_switchboard }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.site_switchboard == null
                      ? "EMPTY"
                      : accountDataDescription.site_switchboard
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.site_switchboard == null
                      ? "EMPTY"
                      : accountDataDescription.site_switchboard
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].web != accountDataDescriptions[1].web
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].web != accountDataDescriptions[1].web
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Web :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.web != null &&
                      accountDataDescriptions[0].web !=
                        accountDataDescriptions[1].web
                  "
                  v-model="accounts.web"
                  :vs-value="accountDataDescription.web"
                  class="mr-4"
                  vs-name="web"
                  >{{ accountDataDescription.web }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.web == null
                      ? "EMPTY"
                      : accountDataDescription.web
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.web == null
                      ? "EMPTY"
                      : accountDataDescription.web
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].linkedin !=
              accountDataDescriptions[1].linkedin
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].linkedin !=
              accountDataDescriptions[1].linkedin
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Linkedin :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.linkedin != null &&
                      accountDataDescriptions[0].linkedin !=
                        accountDataDescriptions[1].linkedin
                  "
                  v-model="accounts.linkedin"
                  :vs-value="accountDataDescription.linkedin"
                  class="mr-4"
                  vs-name="linkedin"
                  >{{ accountDataDescription.linkedin }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.linkedin == null
                      ? "EMPTY"
                      : accountDataDescription.linkedin
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.linkedin == null
                      ? "EMPTY"
                      : accountDataDescription.linkedin
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(accountDataDescription, index) in accountDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
          v-if="
            accountDataDescriptions[0].phone != accountDataDescriptions[1].phone
          "
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              accountDataDescriptions[0].phone !=
              accountDataDescriptions[1].phone
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>Phone :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    accountDataDescription.phone != null &&
                      accountDataDescriptions[0].phone !=
                        accountDataDescriptions[1].phone
                  "
                  v-model="accounts.phone"
                  :vs-value="accountDataDescription.phone"
                  class="mr-4"
                  vs-name="phone"
                  >{{ accountDataDescription.phone }}
                </vs-radio>

                <span v-else>
                  {{
                    accountDataDescription.phone == null
                      ? "EMPTY"
                      : accountDataDescription.phone
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    accountDataDescription.phone == null
                      ? "EMPTY"
                      : accountDataDescription.phone
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
          <div class="text-center">
            <vs-button @click.prevent="submitForm">Submit</vs-button>
          </div>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import vSelect from "vue-select";
import _ from "lodash";
export default {
  data: () => ({
    match_accounts: [],
    accounts: {
      company_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      head_office_country: null,
      company_registration_number: null,
      registration_jurisdiction: null,
      status: null,
      parent: null,
      web: null,
      phone: null,
      linkedin: null,
      country: null,
      revenue: null,
      no_of_employees: null
    },
    accountDataDescriptions: {},
    enrichAccountDataToMasterDBPopUp: false,
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    campaignDescription: {},
    enrichAccountDataToMasterDB: []
  }),
  components: {
    "v-select": vSelect,
    DataGrid
  },
  methods: {
    submitForm() {
      this.accounts.old_csv_ml_id = this.accountDataDescriptions[1].ml_id;
      this.accounts.new_csv_ml_id = this.accountDataDescriptions[0].ml_id;
      this.accounts.campaignId = this.campaignId;

      let self = this;
      this.$store
        .dispatch("accountsManagement/updateOldCsvAccountData", this.accounts)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "CSV Updated",
              text: "The csv account was update successfully."
            });
            this.enrichAccountDataToMasterDBPopUp = false;
            this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })

      // alert("ASdadasd");
    },
    completedDeduplicate() {
      this.$router
        .push("/accounts/enrichAccountDataToMasterDb/" + this.campaignId)
        .catch(() => {});
    },
    acceptToUpdate(data) {
      this.accountDataDescriptions = this.match_accounts[data["accepted"]];

      // console.log(data);

      this.accounts = {
        switchboard: null,
        site_switchboard: null,
        company_name: null,
        registered_office_address_1: null,
        registered_office_address_2: null,
        registered_office_address_3: null,
        registered_office_city: null,
        registered_office_county: null,
        registered_office_postcode: null,
        registered_office_country: null,
        head_office_address_1: null,
        head_office_address_2: null,
        head_office_address_3: null,
        head_office_city: null,
        head_office_county: null,
        head_office_postcode: null,
        head_office_country: null,
        company_registration_number: null,
        registration_jurisdiction: null,
        status: null,
        parent: null,
        web: null,
        phone: null,
        linkedin: null,
        country: null,
        revenue: null,
        no_of_employees: null
      };
      this.enrichAccountDataToMasterDBPopUp = true;
    },
    IgnoreUpdateToMasterDB(data) {
      this.accounts.new_csv_ml_id = data.ml_id;
      this.accounts.campaignId = this.campaignId;
      let self = this;

      this.$store
        .dispatch("accountsManagement/ignoreCsvAccountNewData", this.accounts)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Account Ignored",
              text: "This csv account has been ignored."
            });
            this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    goBack: function() {
      this.$router.go(-1);
    },
    formatUploadedHeader(s) {
      if (typeof s.toLowerCase()  !== "string") return "";
      if (s.startsWith("ml_")) return "";
      if (s === "master_db_account") return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
    matchedData() {
      let data = {};
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/accounts/deduplicate_csv_accounts_data",
          data
        )
        .then(response => {
          this.match_accounts = JSON.parse(response.data);
          // this.match_accounts.forEach(function(ele) {
          //   if (ele.no_of_employees != null) {
          //     ele.no_of_employees = parseInt(ele.no_of_employees);
          //   }

          //   if (ele.revenue != null) {
          //     ele.revenue = parseInt(ele.revenue);
          //   }
          //   return ele;
          // });

          if (this.match_accounts.length == 0) {
            this.$vs.notify({
              color: "success",
              title: "Duplicate Accounts",
              text: "There are no duplicate accounts on csv. You may enrich campaign account data to master database"
            });
            this.$router
              .push(
                "/accounts/optionsAfterImportAccountToCampaign/" +
                  this.campaignId
              )
              .catch(() => {});
          } else {
            this.match_accounts = _.groupBy(this.match_accounts, "accepted");
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.matchedData();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;

    // this.getAssocaitedAccountsAccounts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
